<template>
  <div class="columns">
    <div class="column is-narrow">
      <div class="card">
        <div class="card-content pd-10px">
          <div class="columns">
            <div class="column is-narrow zoom-06">
              <div class="reseauTempoImage"/>
            </div>
            <div class="column is-8">
              <p class="has-text-weight-bold is-size-6" v-if="demandeLogistique.ligneCommande">
                {{ $t('gestionAffectation.informationReseau.titleReseauLc', {
                libelle: demandeLogistique.libelleProduit,
                dateDebut: getDateDebut,
                dateFin: getDateFin,
                }) }}</p>
              <p class="has-text-weight-bold is-size-6" v-if="demandeLogistique.produit">
                {{ $t('gestionAffectation.informationReseau.titleReseau', {
                libelle: demandeLogistique.libelleProduit,
                }) }}</p>
              <p class="has-text-default">
                {{ affectations.length > 1 ?
                $t('gestionAffectation.informationReseau.faceAffectees',
                { faceAffecte: affectations.length }) :
                $t('gestionAffectation.informationReseau.faceAffectee',
                { faceAffecte: affectations.length })}}
                {{ (demandeLogistique.facesDemandees > 1 ?
                $t('gestionAffectation.informationReseau.facesVendues', {
                faceVendu: demandeLogistique.facesDemandees }) :
                $t('gestionAffectation.informationReseau.faceVendue', { faceVendu:
                demandeLogistique.facesDemandees })) }}
              </p>
              <p class="has-text-primary is-size-7">
                {{ getNumberRestriction() > 1
                ? $t('gestionAffectation.informationReseau.restrictions',
                { restriction: getNumberRestriction() }) :
                $t('gestionAffectation.informationReseau.restriction',
                { restriction: getNumberRestriction() }) }}
              </p>
            </div>
            <div class="column is-2 is-flex align-self-center has-text-centered pdl-0">
              <div class="columns is-multiline is-paddingless has-text-centered"
                   v-if="demandeLogistique.facesDemandees - affectations.length > 0">
                <div>
                  <div class="column is-12 is-paddingless">
                    <p class="has-text-danger has-text-weight-bold is-size-4">
                      {{ demandeLogistique.facesDemandees - affectations.length }}
                    </p>
                  </div>
                  <div class="column is-12 is-paddingless has-text-centered is-size-7">
                    <p class="has-text-danger">
                      {{ $t('gestionAffectation.informationReseau.faceAaffecter') }}
                    </p>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="column is-12">
                  <b-icon icon="checkbox-marked-circle" type="is-success" size="is-medium">
                  </b-icon>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <qd-switch class="has-text-default column is-narrow pdt-0"
                      @input="$emit('makeRecherche')"
                      v-model="filtres.estAffecteReseau">
              {{ $t('gestionAffectation.informationReseau.afficherFaceReseau') }}
            </qd-switch>
            <qd-switch class="has-text-default column is-narrow pdt-0"
                      @input="$emit('makeRecherche')"
                      v-model="filtres.estAffecteDemande">
              {{ $t('gestionAffectation.informationReseau.afficherFace') }}
            </qd-switch>
            <div class="column is-narrow pdt-0">
              <button class="button is-primary"
                @click="popUpInfoFaceIssuePartielle = true">
                <b-icon icon="format-list-bulleted" type="is-white">
                </b-icon>
                <span class="has-text-white">
                  {{$t('gestionAffectation.informationReseau.afficherFaceVentePartielle')}}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="popUpInfoFaceIssuePartielle"
      width="75%"
      class="modal"
      has-modal-card>
      <demande-selection-faces :demandeLogistique="demandeLogistique" />
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { AFFECTATION } from '@/configuration/logistique/permissionsLogistiqueConf';
import demandeSelectionFaces
  from '@/components/commande/logistique/p_demandeSelectionFaces';
import formatDate from '@/services/general/formatDate';

const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'affectationReseau',
  data() {
    return {
      permAffectation: AFFECTATION,
      popUpInfoFaceIssuePartielle: false,
    };
  },
  components: {
    demandeSelectionFaces,
  },
  props: {
    demandeLogistique: {
      required: true,
      type: Object,
    },
    affectations: {
      required: true,
      type: Array,
    },
    filtres: {
      required: true,
      type: Object,
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    getNumberRestriction() {
      let nbRestriction = 0;
      this.affectations.forEach((affectation) => {
        if (affectation.restrictionsAffichage !== '') nbRestriction += 1;
      });
      return nbRestriction;
    },
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    getDateDebut() {
      return formatDate(this.demandeLogistique.ligneCommande.dateDebut);
    },
    getDateFin() {
      return formatDate(this.demandeLogistique.ligneCommande.dateFin);
    },
  },
};
</script>

<style scoped>

</style>
